import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppSharedRepositoryPort } from 'application/common/port/app-shared-repository.port';
import { UserUsageStats } from 'user/user-usage-stats';

import {
	AppSharedRepositoryState,
	AppSharedRepositoryStore,
} from './app-shared-repository.store';

@Injectable()
export class AppSharedRepositoryAdapter
	extends Query<AppSharedRepositoryState>
	implements AppSharedRepositoryPort
{
	constructor(store: AppSharedRepositoryStore) {
		super(store);
	}

	public observeUserPendingMessages(): Observable<{ [p: string]: number }> {
		return this.select('userPendingMessages');
	}

	public observeUserUsageStats(): Observable<UserUsageStats> {
		return this.select('userUsageStats').pipe(
			map(
				(stats) =>
					new UserUsageStats(
						stats.doneTasks,
						stats.pendingTasks,
						stats.doneJobMeetings,
						stats.pendingJobMeetings,
						stats.doneContactMeetings,
						stats.pendingContactMeetings,
						stats.messagesSent,
						stats.messagesSentMax,
						stats.messagesSentPeriod
					)
			)
		);
	}

	public saveUserPendingMessages(pendingMessages: { [p: string]: number }) {
		this.store.update((state) => ({
			userPendingMessages: { ...state.userPendingMessages, ...pendingMessages },
		}));
	}

	public saveUserUsageStats(userUsageStats: UserUsageStats): Promise<void> {
		return this.store.update({
			userUsageStats: {
				doneTasks: userUsageStats.doneTasks,
				pendingTasks: userUsageStats.pendingTasks,
				doneJobMeetings: userUsageStats.doneJobMeetings,
				pendingJobMeetings: userUsageStats.pendingJobMeetings,
				doneContactMeetings: userUsageStats.doneContactMeetings,
				pendingContactMeetings: userUsageStats.pendingContactMeetings,
				messagesSent: userUsageStats.messagesSent || 0,
				messagesSentMax: userUsageStats.messagesSentMax || 100,
				messagesSentPeriod: userUsageStats.messagesSentPeriod || 1,
			},
		});
	}
}
